import React, { Component } from "react";
import { Row, Col } from "reactstrap";
import InstructorForm from "./InstructorForm";
import ViewInstructorDetails from "./ViewInstructorDetails";
import InstructorTable from "./InstructorTable";
import { interestService } from "./services/instructor.service";
import { toast } from "react-toastify";

class ManageInstructor extends Component {
  state = {
    fetching: false,
    submitting: false,
    formError: null,
    data: null,
    selectedRow: null,
    hasParams: false,
    error: null,
    pageNum: 0,
    pageSize: 10,
    pages: null,
    viewProfile: false,
    showInterests: false,
    InstructorInterests: null,
    editmode: false,
    submitSucessful: false,
    showNextJoyRide:false,
    showJoyRideOnTable:false
  };

  componentDidMount() {
    const { pageNum, pageSize } = this.state;
    this.getAllInstructors({ pageNum: pageNum + 1, pageSize });
    if (this.props.location.state) {
      const { run } = this.props.location.state;
      if (run) {
        this.setState({ showNextJoyRide: run });
      } else {
        return;
      }
    }
  }

  getAllInstructors = params => {
    this.setState({ fetching: true });
    interestService
      .getAllInstructor(params)
      .then(response => {
        response &&
          this.setState({
            data: response,
            pages: Math.ceil(response.count / params.pageSize),
            error: null,
            fetching: false
          });
      })
      .catch(error => this.setState({ error, fetching: false }));
  };

  addInstructor = data => {
    const { pageSize, selectedRow } = this.state;
    this.setState({
      submitting: true,
      formError: null,
      submitSucessful: false
    });
    interestService
      .addInstructor(data, selectedRow && selectedRow.id)
      .then(response => {
        this.setState({
          response,
          formError: null,
          InstructorInterests: null,
          submitting: false,
          submitSucessful: true
        });
        this.getAllInstructors({ pageNum: 1, pageSize });
        if (!selectedRow) {
          toast.success("Instructor created successfully", {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 4000
          });
        } else {
          toast.success("Instructor updated successfully", {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 4000
          });
          this.resetButton();
        }
      })
      .catch(error => this.setState({ formError: error, submitting: false }));
  };

  getInstructorInterests = id => {
    this.setState({ submitting: true, InstructorInterests: null });
    interestService
      .getInstructor(id)
      .then(response => {
        response &&
          this.setState({
            InstructorInterests: response.interests,
            error: null,
            fetching: false,
            submitting: false
          });
      })
      .catch(error => this.setState({ formError: error, submitting: false }));
  };

  selectRow = selectedRow => {
    this.getInstructorInterests(selectedRow.original.id);
    this.setState({
      selectedRow: selectedRow.original,
      hasParams: true,
      viewProfile: false,
      editmode: true
    });
  };

  ViewInstructorSelectRow = selectedRow => {
    this.getInstructorInterests(selectedRow.original.id);
    this.setState({
      selectedRow: selectedRow.original,
      hasParams: true,
      viewProfile: true,
      showInterests: true,
      editmode: true
    });
  };

  deleteInstructor = item => {
    if (item && item.original) {
      interestService
        .deleteInstructor(item.original.id)
        .then(response => {
          this.fetchData();
        })
        .catch(error => this.setState({ error, submitting: false }));
    }
  };
  resetButton = () => {
    this.setState({
      hasParams: false,
      submitting: false,
      selectedRow: null,
      viewProfile: false,
      showInterests: false,
      submitSucessful: false,
      editmode: false,
      InstructorInterests: null
    });
  };

  fetchData = () => {
    const { pageNum, pageSize, filterParams } = this.state;
    let params = { pageNum: pageNum + 1, pageSize };
    if (filterParams) {
      params = { ...filterParams, ...params };
    }
    this.getAllInstructors(params);
  };

  setPageNumber = pageIndex => {
    this.setState({ pageNum: pageIndex }, () => this.fetchData());
  };

  setPageSize = (pageSize, pageIndex) => {
    this.setState({ pageSize, pageNum: pageIndex }, () => this.fetchData());
  };

  filterData = params => {
    this.setState({ filterParams: params, pageNum: 0 }, () => this.fetchData());
  };
//========================TOUR GUIDE========================//
setNextJoyRide=()=>{
  this.setState({showNextJoyRide:false})
}

startJoyRideAtDataTable=()=>{
 this.setState({showJoyRideOnTable:true})
}

stopJoyRideAtDataTable=()=>{
  this.setState({showJoyRideOnTable:false})
 }

 routeChange = () => {
  this.props.history.push({
    pathname: `/dashboard`,
    state: { run: true },
  });
};
  render() {
    const {
      fetching,
      data,
      pages,
      pageNum,
      pageSize,
      error,
      submitting,
      formError,
      hasParams,
      InstructorInterests,
      submitSucessful,
      showInterests,
      selectedRow,
      showNextJoyRide,
      showJoyRideOnTable
    } = this.state;

    return (
      <div>
        <Row>
          <Col sm="4">
            {this.state.viewProfile ? (
              <ViewInstructorDetails
                hasParams={hasParams}
                selectedRow={selectedRow}
                reset={this.resetButton}
                submitting={submitting}
                InstructorInterests={InstructorInterests}
                showInterests={showInterests}
                editmode={this.state.editmode}
              />
            ) : (
              <InstructorForm
                submitting={submitting}
                error={formError}
                InstructorInterests={InstructorInterests}
                hasParams={hasParams}
                selectedRow={selectedRow}
                submitAction={this.addInstructor}
                submitSucessful={submitSucessful}
                reset={this.resetButton}
                showNextJoyRide={showNextJoyRide}
              setNextJoyRide={this.setNextJoyRide}
              startJoyRideAtDataTable={this.startJoyRideAtDataTable}
              />
            )}
          </Col>
          <Col sm="8">
            <InstructorTable
              fetching={fetching}
              hasParams={hasParams}
              selectedRow={selectedRow}
              data={data}
              selectRow={this.selectRow}
              ViewInstructorSelectRow={this.ViewInstructorSelectRow}
              error={error}
              DeleteModal={this.DeleteModal}
              deleteInterest={this.deleteInstructor}
              pages={pages}
              page={pageNum}
              pageSize={pageSize}
              filterData={this.filterData}
              setPageNumber={this.setPageNumber}
              setPageSize={this.setPageSize}
              showJoyRideOnTable={showJoyRideOnTable}
              stopJoyRideAtDataTable={this.stopJoyRideAtDataTable}
              routeChange={this.routeChange}
            />
          </Col>
        </Row>
      </div>
    );
  }
}

export default ManageInstructor;
